import 'antd/dist/antd.min.css';
import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import MeetingScreen from './components/MeetingScreen';
import AuthContextProvider from './contexts/AuthContext';
import ConversationContextProvider, {
  userIdChannel,
} from './contexts/ConversationContext';
import UserContextProvider from './contexts/UserContext';
import Auth from './layouts/Auth';
import LayoutPage from './layouts/LayoutPage';
import Login from './views/Auth/Login';
import Error from './views/Error';
import Home from './views/Home';
// import Register from './views/Auth/Register';
// import ActivateAccount from './views/Auth/ActivateAccount';
// import ResetPassword from './views/Auth/ResetPassword';

function App() {
  useEffect(() => {
    return () => {
      userIdChannel?.close();
    };
  }, []);

  return (
    <AuthContextProvider>
      <ConversationContextProvider>
        <UserContextProvider>
          <BrowserRouter>
            <Routes>
              <Route path="" element={<LayoutPage />}>
                <Route index element={<Home />} />
                <Route
                  path="conversations/:conversationId"
                  element={<Home />}
                />
                <Route path="meeting" element={<MeetingScreen />} />
              </Route>

              <Route path="" element={<Auth />}>
                <Route path="login" element={<Login />} />
                {/* <Route path="register" element={<Register />} />
                <Route path="activate-account" element={<ActivateAccount />} />
                <Route path="reset-password" element={<ResetPassword />} /> */}
              </Route>
              <Route path="*" element={<Error />} />
            </Routes>
          </BrowserRouter>
        </UserContextProvider>
      </ConversationContextProvider>
    </AuthContextProvider>
  );
}

export default App;
